import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const advancePaymentData = this.props.advancedPaymentList;
    const advancedPaymentList = this.props.searchData;
   

    return (
      <div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <h3><center><u>Outlet Order Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{advancedPaymentList.groupName} - {advancedPaymentList.outletName}</center></h4>
        <h4><center>{advancedPaymentList.date}</center></h4>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow>
                    <TableCell align={'left'}>Product Name</TableCell>
                    <TableCell align={'left'}>Product Code</TableCell>
                    <TableCell align={'left'}>Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {advancePaymentData.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.productName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.productCode}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.quantity}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
      </div>
      
    );
  }
}
